export enum ReportsStatus {
  PENDING = 'pending',
  DONE = 'done',
  INVALID = 'invalid'
}
